import { render, staticRenderFns } from "./lottie.vue?vue&type=template&id=ea52fd3c&"
import script from "./lottie.vue?vue&type=script&lang=ts&"
export * from "./lottie.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports